export function isWidgetConfigurationValid(widgetData) {
  const displayedWidgets = Object.entries(widgetData || {}).filter(
    ([, widget]) => widget?.display
  );
  const positions = displayedWidgets.map(([, widget]) => Number(widget.position));

  if (
    positions.some((position) => !Number.isInteger(position) || position <= 0) ||
    new Set(positions).size !== positions.length
  ) {
    return false;
  }

  return displayedWidgets.every(([widgetName, widget]) => {
    if (widget.number_of_days_to_show === undefined) return true;

    const days = Number(widget.number_of_days_to_show);
    const minimumDays = widgetName === "reward_card" ? 1 : 0;
    return Number.isInteger(days) && days >= minimumDays;
  });
}
